import { cloneName } from '../javascripts/name';

function update(values, names) {
  Object
    .keys(names || {})
    .forEach((i) => { values.value[i] = names[i]; });
}

export default function callbacker(props, planter) {
  const {
    values,
    loadings,
  } = planter;

  async function callback(name, value) {
    const found = props.callbacks[name] || props.callbacks[cloneName(name)];

    let names = found?.(props, planter, name, value);

    const {
      promise,
      loading,
      partial,
    } = names || {};

    if (promise) {
      const multiple = Array.isArray(promise);
      const _promises = multiple ? promise : [promise];
      const _loadings = multiple ? loading : [loading];
      const _partials = multiple ? partial : [partial];

      // eslint-disable-next-line no-unused-vars
      _promises.forEach(async (_, index) => {
        update(values, _partials[index]);

        _loadings[index].forEach((i) => { loadings.value[i] = true; });
        names = await _promises[index];
        _loadings[index].forEach((i) => { loadings.value[i] = false; });

        update(values, names);
      });
    } else {
      update(values, names);
    }

    document.querySelector(':focus')?.blur();
  }

  return {
    callback,
  };
}
